"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNextQuestionIdOrIndex = exports.getItemInputValue = exports.redirectToUrl = exports.ChatbotBrain = void 0;
const models_1 = require("../models");
const utils_1 = require("./utils");
const variables_1 = require("./variables");
class ChatbotBrain {
    constructor(context) {
        this.context = context;
        this.executeLogicJumps = (logicJumps) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { nextId, validatedConditionId } = yield this.executeConditions((_a = logicJumps.conditions) !== null && _a !== void 0 ? _a : []);
            if (nextId)
                return { nextQuestionIdOrIndex: nextId, validatedConditionId };
            if (!logicJumps.defaultThen)
                return {};
            return {
                nextQuestionIdOrIndex: yield this.executeThen(logicJumps.defaultThen),
            };
        });
        this.executeConditions = (conditions) => __awaiter(this, void 0, void 0, function* () {
            let nextId, validatedConditionId;
            let i = 0;
            for (const condition of conditions) {
                i += 1;
                if (this.isConditionValidated(condition)) {
                    validatedConditionId = condition.id;
                    nextId = yield this.executeThen(condition.then);
                }
                if (nextId) {
                    const otherNonLogicJumpsConditions = conditions
                        .slice(i)
                        .filter((condition) => getThenType(condition.then) !== models_1.ThenType.JUMP);
                    this.executeConditions(otherNonLogicJumpsConditions);
                    return { nextId, validatedConditionId };
                }
            }
            return {};
        });
        this.executeThen = (then) => __awaiter(this, void 0, void 0, function* () {
            if ("targetId" in then && then.targetId) {
                return then.targetId;
            }
            if ("url" in then) {
                yield this.executeRedirection(then);
            }
            if ("webhookUrl" in then) {
                yield this.executeHttpRequest(then);
            }
            else {
                this.executeComputation(then);
            }
        });
        this.executeRedirection = ({ options, url }) => __awaiter(this, void 0, void 0, function* () {
            var _b;
            const { variables } = this.context.chatbot;
            const { onChatbotAnswer } = this.context.actions;
            if ((options === null || options === void 0 ? void 0 : options.tab) === "current") {
                const isFormBeingConsumed = ((_b = [...this.context.answers].pop()) === null || _b === void 0 ? void 0 : _b.questionId) && onChatbotAnswer;
                if (isFormBeingConsumed) {
                    this.context.answers[this.context.answers.length - 1].isRedirected =
                        true;
                    yield onChatbotAnswer([...this.context.answers]);
                }
                return (0, exports.redirectToUrl)({
                    url: (0, variables_1.parseVariables)(url, variables),
                    params: options,
                });
            }
            (0, exports.redirectToUrl)({
                url: (0, variables_1.parseVariables)(url, variables),
                params: options,
            });
        });
        this.executeHttpRequest = (params) => __awaiter(this, void 0, void 0, function* () {
            var _c;
            const { setIsExecutingHttpRequest, setHttpVariableValue } = this.context.actions;
            setIsExecutingHttpRequest(true);
            const { variables } = this.context.chatbot;
            let sameUrlPreviouslyCalled;
            const url = "id" in params ? `https://public.com/${params.id}` : params.webhookUrl;
            try {
                sameUrlPreviouslyCalled =
                    (0, utils_1.getItemFromLocalStorage)("recentHttpRequestUrl") === url;
                if (sameUrlPreviouslyCalled) {
                    yield debounceRequest(url);
                }
                saveRequestUrlInLocalStorage(url);
            }
            catch (err) {
                /*localStorage not available... Ignoring*/
                notifyCatchedError(err);
            }
            try {
                const response = "id" in params
                    ? yield this.executePrivateHttpRequest(params, variables)
                    : yield this.executePublicHttpRequest(params, variables);
                const body = yield response.json().catch(() => "Empty body");
                ((_c = params.responseMapping) !== null && _c !== void 0 ? _c : []).map(({ bodyPath, variableId }) => {
                    const value = eval(`(${JSON.stringify(body)}).${bodyPath}`);
                    if (!(0, utils_1.isDefined)(value))
                        return;
                    setHttpVariableValue({ value, variableId });
                    this.updateHttpVariables({ value, variableId });
                });
            }
            catch (err) {
                console.error(err);
                notifyCatchedError(err, JSON.stringify(params));
            }
            setIsExecutingHttpRequest(false);
        });
        this.executePrivateHttpRequest = (params, variables) => __awaiter(this, void 0, void 0, function* () {
            return fetch(`${(0, utils_1.getCloudFunctionsOrigin)()}/${params.id}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify({
                    variables,
                }),
            });
        });
        this.executePublicHttpRequest = (params, variables) => __awaiter(this, void 0, void 0, function* () {
            var _d, _e, _f;
            return fetch(`${(0, utils_1.getCloudFunctionsOrigin)()}/${params.version === 2 ? "sendHttpRequest" : "testHttpRequest"}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify({
                    contentType: params.contentType,
                    webhookUrl: (0, variables_1.parseVariables)(params.webhookUrl, variables),
                    method: (0, variables_1.parseVariables)((_d = params.method) !== null && _d !== void 0 ? _d : "", variables),
                    body: (0, variables_1.parseVariables)((_e = params.body) !== null && _e !== void 0 ? _e : "", variables),
                    headers: (0, variables_1.parseVariables)((_f = params.headers) !== null && _f !== void 0 ? _f : "", variables),
                }),
            });
        });
        this.updateHttpVariables = ({ value, variableId, }) => {
            const httpVariables = this.context.chatbot.variables.httpRequestVariables;
            if (!httpVariables)
                return;
            const index = httpVariables.findIndex((variable) => variable.id === variableId);
            if (index === -1)
                return;
            httpVariables[index].value = value.toString();
        };
        this.executeComputation = (computationParams) => {
            var _a, _b, _c;
            const { variables } = this.context.chatbot;
            const aggregatedVariables = [
                ...variables.computationVariables.map((v) => (Object.assign(Object.assign({}, v), { type: "computation" }))),
                ...variables.questionVariables.map((v) => (Object.assign(Object.assign({}, v), { type: "question" }))),
                ...variables.starterVariables.map((v) => (Object.assign(Object.assign({}, v), { type: "starter" }))),
                ...((_a = variables.httpRequestVariables) !== null && _a !== void 0 ? _a : []).map((v) => (Object.assign(Object.assign({}, v), { type: "http" }))),
            ];
            const variable = aggregatedVariables.find((variable) => variable.id === computationParams.variableId);
            let input;
            if (!computationParams.input)
                return;
            if ("variableId" in computationParams.input) {
                const computationInput = computationParams.input;
                input = parseFloat((_c = (_b = aggregatedVariables.find((variable) => variable.id === computationInput.variableId)) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "");
            }
            else {
                const computationInput = computationParams.input;
                input = computationInput.customNumber;
            }
            if (!variable)
                throw Error("Variable is not defined");
            let baseValue = variable.value;
            if (!baseValue) {
                baseValue = "0";
            }
            const updatedVariablePayload = {
                variableId: variable.id,
                value: compute(baseValue, computationParams.operator, input),
            };
            this.updateComputedVariable(variable.type, updatedVariablePayload);
        };
        this.updateComputationVariables = ({ value, variableId, }) => {
            const { computationVariables } = this.context.chatbot.variables;
            const index = computationVariables.findIndex((variable) => variable.id === variableId);
            if (index === -1)
                return;
            computationVariables[index].value = value.toString();
        };
    }
    computeNextIndex(lastStepDisplayed, startConditions) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let nextIndex = lastStepDisplayed
                ? lastStepDisplayed.chatbotStepIndex + 1
                : 0;
            const logicJumps = lastStepDisplayed
                ? lastStepDisplayed.logicJumps
                : startConditions;
            if (!logicJumps)
                return { nextIndex };
            const { nextQuestionIdOrIndex, validatedConditionId } = yield this.executeLogicJumps(logicJumps);
            nextIndex =
                (_a = (0, exports.parseNextQuestionIdOrIndex)(this.context.chatbot, nextQuestionIdOrIndex)) !== null && _a !== void 0 ? _a : nextIndex;
            return { nextIndex, validatedConditionId };
        });
    }
    isConditionValidated(condition) {
        var _a;
        const { chatbot, answers } = this.context;
        const aggregatedVariables = [
            ...chatbot.variables.computationVariables,
            ...chatbot.variables.questionVariables,
            ...chatbot.variables.starterVariables,
            ...((_a = chatbot.variables.httpRequestVariables) !== null && _a !== void 0 ? _a : []),
        ];
        let conditionValidated = false;
        condition.comparisons.some((comparison, idx) => {
            var _a, _b, _c, _d, _e, _f;
            if (!comparison.input)
                return false;
            let input;
            if ("variableId" in comparison.input) {
                const comparisonInput = comparison.input;
                const variable = aggregatedVariables.find((variable) => variable.id === comparisonInput.variableId);
                input = (_b = (_a = variable === null || variable === void 0 ? void 0 : variable.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : undefined;
                if (variable && !(0, utils_1.isDefined)(input) && "defaultValue" in variable) {
                    input =
                        (_d = (_c = variable.defaultValue) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : undefined;
                }
            }
            else {
                const { questionId } = comparison.input;
                input = (_f = (_e = answers
                    .filter((answer) => answer.questionId === questionId)
                    .pop()) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.toLowerCase();
            }
            let comparisonElement, comparisonValue;
            if (typeof comparison.value === "string") {
                comparisonValue = comparison.value.toLowerCase();
            }
            else {
                comparisonValue = (0, exports.getItemInputValue)(chatbot, comparison.value).toLowerCase();
            }
            switch (comparison.operator) {
                case models_1.ComparisonOperator.EQUALS: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement = input === comparisonValue;
                    break;
                }
                case models_1.ComparisonOperator.NOT_EQUAL: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement = input !== comparisonValue;
                    break;
                }
                case models_1.ComparisonOperator.GREATER: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement =
                        !isNaN(parseFloat(input)) &&
                            parseFloat(input) > parseFloat(comparisonValue);
                    break;
                }
                case models_1.ComparisonOperator.GREATER_OR_EQUAL: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement =
                        !isNaN(parseFloat(input)) &&
                            parseFloat(input) >= parseFloat(comparisonValue);
                    break;
                }
                case models_1.ComparisonOperator.CONTAINS: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement = input.includes(comparisonValue);
                    break;
                }
                case models_1.ComparisonOperator.NOT_CONTAIN: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement = !input.includes(comparisonValue);
                    break;
                }
                case models_1.ComparisonOperator.LESS: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement =
                        !isNaN(parseFloat(input)) &&
                            parseFloat(input) < parseFloat(comparisonValue);
                    break;
                }
                case models_1.ComparisonOperator.LESS_OR_EQUAL: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement =
                        !isNaN(parseFloat(input)) &&
                            parseFloat(input) <= parseFloat(comparisonValue);
                    break;
                }
                case models_1.ComparisonOperator.STARTS_WITH: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement = input.startsWith(comparisonValue);
                    break;
                }
                case models_1.ComparisonOperator.ENDS_WITH: {
                    if (!(0, utils_1.isDefined)(input)) {
                        comparisonElement = false;
                        break;
                    }
                    comparisonElement = input.endsWith(comparisonValue);
                    break;
                }
                case models_1.ComparisonOperator.EMPTY: {
                    comparisonElement = !(0, utils_1.isDefined)(input) || input === "";
                    break;
                }
                case models_1.ComparisonOperator.NOT_EMPTY: {
                    comparisonElement = (0, utils_1.isDefined)(input) && input !== "";
                    break;
                }
            }
            if (idx === 0) {
                conditionValidated = comparisonElement;
            }
            else if (condition.logicalOperators[idx - 1] === models_1.LogicalOperator.OR) {
                conditionValidated = conditionValidated || comparisonElement;
                if (conditionValidated)
                    return true;
            }
            else {
                conditionValidated = conditionValidated && comparisonElement;
                if (!conditionValidated)
                    return true;
            }
        });
        return conditionValidated;
    }
    updateComputedVariable(type, payload) {
        switch (type) {
            case "computation": {
                this.context.actions.setComputationVariableValue(payload);
                this.updateComputationVariables(payload);
                break;
            }
            case "http": {
                this.context.actions.setHttpVariableValue(payload);
                this.updateHttpVariables(payload);
                break;
            }
            default: {
                this.context.actions.setQuestionVariableValue({
                    varIndexOrId: payload.variableId,
                    value: payload.value,
                });
            }
        }
    }
}
exports.ChatbotBrain = ChatbotBrain;
const redirectToUrl = ({ url, params, }) => {
    var _a, _b;
    const formattedUrl = (0, utils_1.sanitizeUrl)(url);
    const isEmbedded = window.parent && window.location !== ((_a = window.top) === null || _a === void 0 ? void 0 : _a.location);
    if (isEmbedded) {
        if ((params === null || params === void 0 ? void 0 : params.tab) !== "new") {
            window.top.location.href = formattedUrl;
            return;
        }
        try {
            window.open(formattedUrl);
        }
        catch (err) {
            //Can't access to parent window
            (_b = window.top) === null || _b === void 0 ? void 0 : _b.postMessage({
                from: "typebot",
                redirectUrl: formattedUrl,
            }, "*");
        }
    }
    else {
        window.open(formattedUrl, (params === null || params === void 0 ? void 0 : params.tab) === "new" ? "_blank" : "_self");
    }
};
exports.redirectToUrl = redirectToUrl;
const getItemInputValue = (chatbot, value) => {
    var _a, _b, _c;
    const questionOptions = (_a = chatbot.steps.find((step) => step.id === value.questionId)) === null || _a === void 0 ? void 0 : _a.questionOptions;
    if (!questionOptions)
        return "";
    return ((_c = (_b = questionOptions.items.find((item) => item.id === value.itemId)) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "");
};
exports.getItemInputValue = getItemInputValue;
const parseNextQuestionIdOrIndex = (chatbot, nextIdOrIndex) => {
    if (!(0, utils_1.isDefined)(nextIdOrIndex))
        return;
    let index;
    if (typeof nextIdOrIndex === "string") {
        index = chatbot.steps.findIndex((step) => step.id === nextIdOrIndex);
        if (nextIdOrIndex === "end") {
            index = chatbot.steps.length;
        }
    }
    else {
        index = nextIdOrIndex;
    }
    return index;
};
exports.parseNextQuestionIdOrIndex = parseNextQuestionIdOrIndex;
const saveRequestUrlInLocalStorage = (url) => {
    if (typeof localStorage === "undefined")
        return;
    if ((0, utils_1.getItemFromLocalStorage)("recentHttpRequestUrl") === url) {
        const currentTotalRetries = (0, utils_1.getItemFromLocalStorage)("totalRetryHttp");
        (0, utils_1.setItemInLocalStorage)("totalRetryHttp", (parseInt(currentTotalRetries !== null && currentTotalRetries !== void 0 ? currentTotalRetries : "2") + 1).toString());
        const isNotBlocked = !(0, utils_1.getItemFromLocalStorage)("blockRequest");
        const hasTooManyRetries = currentTotalRetries && parseInt(currentTotalRetries) >= 5;
        if (hasTooManyRetries && isNotBlocked) {
            (0, utils_1.setItemInLocalStorage)("blockRequest", "true");
        }
    }
    (0, utils_1.setItemInLocalStorage)("recentHttpRequestUrl", url);
};
const debounceRequest = (webhookUrl) => __awaiter(void 0, void 0, void 0, function* () {
    if ((0, utils_1.getItemFromLocalStorage)("recentHttpRequestUrl") === webhookUrl) {
        yield new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 3000);
        });
    }
});
const compute = (baseValue, operator, input) => {
    switch (operator) {
        case models_1.ComputationOperator.ADD: {
            return (parseFloat(baseValue) + input).toString();
        }
        case models_1.ComputationOperator.SUBTRACT: {
            return (parseFloat(baseValue) - input).toString();
        }
        case models_1.ComputationOperator.MULTIPLY: {
            return (parseFloat(baseValue) * input).toString();
        }
        case models_1.ComputationOperator.DIVIDE: {
            return (parseFloat(baseValue) / input).toString();
        }
    }
};
const getThenType = (then) => {
    if ("targetId" in then && then.targetId)
        return models_1.ThenType.JUMP;
    if ("url" in then)
        return models_1.ThenType.REDIRECT;
    if ("webhookUrl" in then)
        return models_1.ThenType.HTTP;
    return models_1.ThenType.COMPUTATION;
};
const notifyCatchedError = (error, extra) => window.postMessage({
    from: "typebot-engine",
    error: error.message,
    extra,
}, "*");
//# sourceMappingURL=logic.js.map